import { AxiosResponse } from "axios";
import request from "./base.service";

function checkPlaque(params: any): Promise<AxiosResponse<any>> {
  return request.build().get(`/api/v1/transport/cars/health/status/plaque`, params)
}

// eslint-disable-next-line
export default {
  checkPlaque
}